import { z } from 'zod';

/**
 * Live sync = small "something changed" pings. They NEVER carry data.
 * After a write commits, the API publishes a ping; browsers refetch the matching queries.
 * Browsers must not depend on pings arriving — they also refetch on focus and reconnect.
 */
/** 'integrations' = connection status, flow modes, mappings or sync issues changed. */
export const LIVE_TOPICS = ['barn-log', 'barns', 'weather', 'system', 'integrations'] as const;
export const liveTopicSchema = z.enum(LIVE_TOPICS);
export type LiveTopic = z.infer<typeof liveTopicSchema>;

export const livePingSchema = z.object({
  topic: liveTopicSchema,
  /** Ids of changed records (optional hint for targeted refetch). */
  ids: z.array(z.string()).max(100).default([]),
  /** Who made the change, so a browser can skip refetching its own write. */
  actorId: z.string().nullable(),
  at: z.iso.datetime(),
});
export type LivePing = z.infer<typeof livePingSchema>;

/** AppSync Events channel for a topic: /<namespace>/<stage>/<topic>. Previews share staging's API. */
export function liveChannel(namespace: string, stage: string, topic: LiveTopic): string {
  return `/${namespace}/${stage}/${topic}`;
}

export const LIVE_NAMESPACE = 'live';
